const InvoiceStatusEnum = {
  1: 'Paid',
  2: 'Unpaid',
  3: 'Partially paid',
  4: 'Canceled',
};

export default InvoiceStatusEnum
